<template>
    <v-container fluid>
        <v-layout>
            <v-flex>{{ currentPoint.order }} - {{ currentPoint.name }}</v-flex>
        </v-layout>
        <v-layout>
            <v-flex xs12>
                <v-textarea
                    outline
                    label="Notas"
                    v-model="checkpoint.notes"
                >                    
                </v-textarea>
            </v-flex>
        </v-layout>
        <v-layout>
            <v-flex xs12>
                <v-btn color="info" @click="takePicture" block>
                    <i class="material-icons"> photo_camera </i><v-spacer></v-spacer> Tomar Fotos
                </v-btn>
                <input type="file" ref="picture" accept="image/*" @change="onTakePictures" capture="camera" style="display: none;">
            </v-flex>
        </v-layout>
        <v-layout v-if="checkpoint.pictures.length > 0" row wrap>
            <v-flex xs4 v-for="(pic, i) in checkpoint.pictures" :key="i">
                <v-img :src="pic"></v-img>
            </v-flex>
        </v-layout>
        <v-layout>
            <v-flex>
                <v-divider></v-divider>
                <v-btn color="primary" block @click="savePoint">Confirmar Punto de Control</v-btn>
            </v-flex>
        </v-layout>
    </v-container>
</template>
<script>
export default {
    data: () => ({
        checkpoint: {
            notes: '',
            pictures: []
        }
    }),
    methods: {
        takePicture() {
            this.$refs.picture.click();
        },
        onTakePictures(e) {
            const fr = new FileReader();
            fr.addEventListener('load', e => {
                // this.photo = e.target.result;
                // this.image.src = e.target.result;
                this.checkpoint.pictures.push(e.target.result);
            });
            fr.readAsDataURL(e.target.files[0]);
        },
        savePoint() {
            
            const roundInProgress = {...this.roundInProgress};
            const checkPoints = [...roundInProgress.checkPoints];
            checkPoints.push({...this.currentPoint, ...this.checkpoint, id: this.currentPoint.id, checkpointDate: this.$dt.now()});

            this.setRoundInProgress({...roundInProgress, checkPoints});

            this.$router.go(-1);
        }
    }
}
</script>
